import styled from 'styled-components'

import Title from '../../components/Title'
import { doubleAddSpace, inAddSpace } from '../../const/commonStyles'
import bgImage from './media/styled/bg.svg'

export const Wrapper = styled.div`
  max-width: 540px;
  margin: 0 auto;
`

export const Content = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  padding-top: 55%;

  background: url(${bgImage}) no-repeat center top;
  background-size: 100% auto;
`

export const Text = styled.p`
  width: 100%;
  margin: 0 0 ${doubleAddSpace};

  text-align: center;
`

export const StyledTitle = styled(Title)`
  text-align: center;
  margin: 0 0 ${inAddSpace};
`
